const main_slider = new Swiper('.kb_slider', {
    slidesPerView: 1,
    loop: true,
    centeredslides: true,
    spaceBetween: 20,
    autoplay: {
        delay: 4000,
    },
    speed: 1000,

    loopAdditionalSlides: 1,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
    el: ".swiper-pagination",
    clickable: true,
    type: 'bullets'
    }

});


const main_slider2 = new Swiper('.collection-hero__fv', {
    slidesPerView: 1,
    loop: true,
    centeredslides: true,
    spaceBetween: 0,
    autoplay: {
        delay: 4000,
    },
    speed: 1000,
    loopAdditionalSlides: 1,
    pagination: {
    el: ".swiper-pagination",
    clickable: true,
    type: 'bullets'
    }

});


$(function(){
   $( 'input[name="色"]' ).change( function() {
    　var radioval = $(this).val();
     var checkedval = $('input[name="色"]:radio:checked' ).val();
     var form_label = $("#form__label").text();
     $("#form__label span").text(checkedval);
     console.log(checkedval)
   });
});

